// components/features/calls/CallList.tsx

import { Call } from '../../../types/features/Call';
import TableList, { SelectAction } from '../../ui/TableList';
import CallRow from './CallRow';

interface CallListProps {
  calls: Call[];
  onAction: (call: Call) => void;
  onSelectCalls?: (selectedCalls: Call[]) => void;
  selectable?: boolean;
  selectActions?: SelectAction[];
}

export default function CallList({
  calls,
  onAction,
  onSelectCalls,
  selectable = false,
  selectActions
}: CallListProps) {
  const columns = [
    { header: "Client / Appel", className: "w-2/5" },
    { header: "Agent", className: "w-2/5" },

    { header: "Durée", className: "hidden sm:table-cell w-1/6" },
    { header: "Enregistrement", className: "hidden md:table-cell w-1/4" },
    { header: "Date", className: "hidden lg:table-cell w-1/6" },
  ];

  return (
    <TableList
      items={calls}
      columns={columns}
      getId={(call) => call.id}
      onAction={onAction}
      onSelectItems={onSelectCalls}
      selectable={selectable}
      emptyMessage="Aucun appel trouvé"
      actionColumn={true}
      selectActions={selectActions}
      renderRow={(call, isSelected, onSelect) => (
        <CallRow
          key={call.id}
          call={call}
          onAction={onAction}
          onSelect={onSelect}
          isSelected={isSelected}
          selectable={selectable}
        />
      )}
    />
  );
}